/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Api2ResponseOfImageUpload,
  Api2ResponseOfInitOrderResult,
  Api2ResponseOfListOfDocumentLinkDTO,
  Api2ResponseOfListOfOrderDTO,
  Api2ResponseOfListOfReturnReasonDTO,
  Api2ResponseOfListOfTimeInterval,
  Api2ResponseOflong,
  Api2ResponseOfOrderDTO,
  Api2ResponseOfPageOfOrderDTO1,
  Api2ResponseOfPageOfReturnInfoDTO,
  Api2ResponseOfReturnInfoDTO,
  CardPaymentOption,
  PaymentOption,
  ReturnInfoDTOReq,
  SplitPaymentOption,
  YandexPayPaymentOption,
  YandexSplitPaymentOption,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Orders<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersUsingGet
   * @summary getBuyerOrders
   * @request GET:/api/v2/orders/buyerOrders
   */
  getBuyerOrdersUsingGet = (
    query?: {
      /** orderStates */
      orderStates?:
        | "CANCELED"
        | "COMPLETED"
        | "CREATED"
        | "DELETED"
        | "HOLD"
        | "HOLD_COMPLETED"
        | "HOLD_COMPLETE_REJECTED"
        | "HOLD_ERROR"
        | "HOLD_PROCESSING"
        | "MONEY_PAYMENT_ERROR"
        | "MONEY_PAYMENT_NOT_ENOUGH"
        | "MONEY_PAYMENT_TECHNICAL_ERROR"
        | "MONEY_PAYMENT_WAIT"
        | "MONEY_TRANSFERRED"
        | "REFUND"
        | "RETURN"
        | "SELLER_PAID";
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/buyerOrders`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersFinishedUsingGet
   * @summary getBuyerOrdersFinished
   * @request GET:/api/v2/orders/buyerOrders/finished
   */
  getBuyerOrdersFinishedUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/buyerOrders/finished`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersFinishedPageUsingGet
   * @summary getBuyerOrdersFinishedPage
   * @request GET:/api/v2/orders/buyerOrders/finishedPage
   */
  getBuyerOrdersFinishedPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
      /** currencyCode */
      currencyCode?: string;
      /** orderSources */
      orderSources?: ("BOUTIQUE" | "ONLINE")[];
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/buyerOrders/finishedPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersInProcessUsingGet
   * @summary getBuyerOrdersInProcess
   * @request GET:/api/v2/orders/buyerOrders/inProcess
   */
  getBuyerOrdersInProcessUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/buyerOrders/inProcess`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersInProcessPageUsingGet
   * @summary getBuyerOrdersInProcessPage
   * @request GET:/api/v2/orders/buyerOrders/inProcessPage
   */
  getBuyerOrdersInProcessPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/buyerOrders/inProcessPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersReturnsUsingGet
   * @summary getBuyerOrdersReturns
   * @request GET:/api/v2/orders/buyerOrders/returns
   */
  getBuyerOrdersReturnsUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/buyerOrders/returns`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersReturnsPageUsingGet
   * @summary getBuyerOrdersReturnsPage
   * @request GET:/api/v2/orders/buyerOrders/returnsPage
   */
  getBuyerOrdersReturnsPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/buyerOrders/returnsPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerOrdersPageUsingGet
   * @summary getBuyerOrdersPage
   * @request GET:/api/v2/orders/buyerOrdersPage
   */
  getBuyerOrdersPageUsingGet = (
    query?: {
      /** orderStates */
      orderStates?:
        | "CANCELED"
        | "COMPLETED"
        | "CREATED"
        | "DELETED"
        | "HOLD"
        | "HOLD_COMPLETED"
        | "HOLD_COMPLETE_REJECTED"
        | "HOLD_ERROR"
        | "HOLD_PROCESSING"
        | "MONEY_PAYMENT_ERROR"
        | "MONEY_PAYMENT_NOT_ENOUGH"
        | "MONEY_PAYMENT_TECHNICAL_ERROR"
        | "MONEY_PAYMENT_WAIT"
        | "MONEY_TRANSFERRED"
        | "REFUND"
        | "RETURN"
        | "SELLER_PAID";
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/buyerOrdersPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetFinishedOrdersForBuyerUsingGet
   * @summary getFinishedOrdersForBuyer
   * @request GET:/api/v2/orders/finishedOrdersForBuyer
   */
  getFinishedOrdersForBuyerUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/finishedOrdersForBuyer`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetFinishedOrdersForSellerUsingGet
   * @summary getFinishedOrdersForSeller
   * @request GET:/api/v2/orders/finishedOrdersForSeller
   */
  getFinishedOrdersForSellerUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/finishedOrdersForSeller`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetReturnReasonsUsingGet
   * @summary getReturnReasons
   * @request GET:/api/v2/orders/return-reasons
   */
  getReturnReasonsUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfReturnReasonDTO, void>({
      path: `/api/v2/orders/return-reasons`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name InitReturnUsingPost
   * @summary initReturn
   * @request POST:/api/v2/orders/returns
   */
  initReturnUsingPost = (data: ReturnInfoDTOReq, params: RequestParams = {}) =>
    this.request<Api2ResponseOflong, void>({
      path: `/api/v2/orders/returns`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetBuyerReturnsPageUsingGet
   * @summary getBuyerReturnsPage
   * @request GET:/api/v2/orders/returns/buyer
   */
  getBuyerReturnsPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfReturnInfoDTO, void>({
      path: `/api/v2/orders/returns/buyer`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerReturnsPageUsingGet
   * @summary getSellerReturnsPage
   * @request GET:/api/v2/orders/returns/seller
   */
  getSellerReturnsPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfReturnInfoDTO, void>({
      path: `/api/v2/orders/returns/seller`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetReturnInfoUsingGet
   * @summary getReturnInfo
   * @request GET:/api/v2/orders/returns/{returnInfoId}
   */
  getReturnInfoUsingGet = (returnInfoId: number, params: RequestParams = {}) =>
    this.request<Api2ResponseOfReturnInfoDTO, void>({
      path: `/api/v2/orders/returns/${returnInfoId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersUsingGet
   * @summary getSellerOrders
   * @request GET:/api/v2/orders/sellerOrders
   */
  getSellerOrdersUsingGet = (
    query?: {
      /** orderStates */
      orderStates?:
        | "CANCELED"
        | "COMPLETED"
        | "CREATED"
        | "DELETED"
        | "HOLD"
        | "HOLD_COMPLETED"
        | "HOLD_COMPLETE_REJECTED"
        | "HOLD_ERROR"
        | "HOLD_PROCESSING"
        | "MONEY_PAYMENT_ERROR"
        | "MONEY_PAYMENT_NOT_ENOUGH"
        | "MONEY_PAYMENT_TECHNICAL_ERROR"
        | "MONEY_PAYMENT_WAIT"
        | "MONEY_TRANSFERRED"
        | "REFUND"
        | "RETURN"
        | "SELLER_PAID";
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/sellerOrders`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersAwaitingConfirmationUsingGet
   * @summary getSellerOrdersAwaitingConfirmation
   * @request GET:/api/v2/orders/sellerOrders/awaitingConfirmation
   */
  getSellerOrdersAwaitingConfirmationUsingGet = (
    query?: {
      /** currencyCode */
      currencyCode?: string;
      /** orderSources */
      orderSources?: ("BOUTIQUE" | "ONLINE")[];
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/sellerOrders/awaitingConfirmation`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersAwaitingConfirmationPageUsingGet
   * @summary getSellerOrdersAwaitingConfirmationPage
   * @request GET:/api/v2/orders/sellerOrders/awaitingConfirmationPage
   */
  getSellerOrdersAwaitingConfirmationPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/sellerOrders/awaitingConfirmationPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersFinishedUsingGet
   * @summary getSellerOrdersFinished
   * @request GET:/api/v2/orders/sellerOrders/finished
   */
  getSellerOrdersFinishedUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/sellerOrders/finished`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersFinishedPageUsingGet
   * @summary getSellerOrdersFinishedPage
   * @request GET:/api/v2/orders/sellerOrders/finishedPage
   */
  getSellerOrdersFinishedPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/sellerOrders/finishedPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersInProcessUsingGet
   * @summary getSellerOrdersInProcess
   * @request GET:/api/v2/orders/sellerOrders/inProcess
   */
  getSellerOrdersInProcessUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/sellerOrders/inProcess`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersInProcessPageUsingGet
   * @summary getSellerOrdersInProcessPage
   * @request GET:/api/v2/orders/sellerOrders/inProcessPage
   */
  getSellerOrdersInProcessPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
      /** currencyCode */
      currencyCode?: string;
      /** orderSources */
      orderSources?: ("BOUTIQUE" | "ONLINE")[];
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/sellerOrders/inProcessPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersPaymentsUsingGet
   * @summary getSellerOrdersPayments
   * @request GET:/api/v2/orders/sellerOrders/payments
   */
  getSellerOrdersPaymentsUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/sellerOrders/payments`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersPaymentsPageUsingGet
   * @summary getSellerOrdersPaymentsPage
   * @request GET:/api/v2/orders/sellerOrders/paymentsPage
   */
  getSellerOrdersPaymentsPageUsingGet = (
    query?: {
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/sellerOrders/paymentsPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetSellerOrdersPageUsingGet
   * @summary getSellerOrdersPage
   * @request GET:/api/v2/orders/sellerOrdersPage
   */
  getSellerOrdersPageUsingGet = (
    query?: {
      /** orderStates */
      orderStates?:
        | "CANCELED"
        | "COMPLETED"
        | "CREATED"
        | "DELETED"
        | "HOLD"
        | "HOLD_COMPLETED"
        | "HOLD_COMPLETE_REJECTED"
        | "HOLD_ERROR"
        | "HOLD_PROCESSING"
        | "MONEY_PAYMENT_ERROR"
        | "MONEY_PAYMENT_NOT_ENOUGH"
        | "MONEY_PAYMENT_TECHNICAL_ERROR"
        | "MONEY_PAYMENT_WAIT"
        | "MONEY_TRANSFERRED"
        | "REFUND"
        | "RETURN"
        | "SELLER_PAID";
      /**
       * page
       * @format int32
       */
      page?: number;
      /**
       * pageSize
       * @format int32
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfPageOfOrderDTO1, void>({
      path: `/api/v2/orders/sellerOrdersPage`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetTimeIntervalsUsingGet
   * @summary getTimeIntervals
   * @request GET:/api/v2/orders/timeIntervals
   */
  getTimeIntervalsUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfTimeInterval, void>({
      path: `/api/v2/orders/timeIntervals`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetAvailablePickupDatesUsingGet
   * @summary getAvailablePickupDates
   * @request GET:/api/v2/orders/availablePickupDates
   */
  getAvailablePickupDatesUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfImageUpload, void>({
      path: `/api/v2/orders/availablePickupDates`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetAvailablePickupDatesForOrderUsingGet
   * @summary getAvailablePickupDatesForOrder
   * @request GET:/api/v2/orders/{orderId}/availablePickupDates
   */
  getAvailablePickupDatesForOrderUsingGet = (
    orderId: number,
    query?: {
      /**
       * daysToLookUp
       * @format int32
       */
      daysToLookUp?: number;
      /**
       * daysToReturn
       * @format int32
       */
      daysToReturn?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/availablePickupDates`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetUnfinishedOrdersUsingGet
   * @summary getUnfinishedOrders
   * @request GET:/api/v2/orders/unfinished
   */
  getUnfinishedOrdersUsingGet = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfOrderDTO, void>({
      path: `/api/v2/orders/unfinished`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetOrderUsingGet
   * @summary getOrder
   * @request GET:/api/v2/orders/{orderId}
   */
  getOrderUsingGet = (orderId: number, params: RequestParams = {}) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name DeleteOrderUsingDelete
   * @summary deleteOrder
   * @request DELETE:/api/v2/orders/{orderId}
   */
  deleteOrderUsingDelete = (orderId: number, params: RequestParams = {}) =>
    this.request<Api2ResponseOflong, void>({
      path: `/api/v2/orders/${orderId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name ConfirmOrderUsingPatch
   * @summary confirmOrder
   * @request PATCH:/api/v2/orders/{orderId}/confirm
   */
  confirmOrderUsingPatch = (orderId: number, params: RequestParams = {}) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/confirm`,
      method: "PATCH",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name ConfirmOrderPositionUsingPatch
   * @summary confirmOrderPosition
   * @request PATCH:/api/v2/orders/{orderId}/confirmPosition
   */
  confirmOrderPositionUsingPatch = (
    orderId: number,
    query: {
      /**
       * orderPositionId
       * @format int64
       */
      orderPositionId: number;
      /** doConfirmSale */
      doConfirmSale: boolean;
      /** type of sale rejection reason */
      reasonType?:
        | "CHANGE_DECISION"
        | "SOLD_ON_OTHER_PLATFORM"
        | "GOING_TO_CHANGE_PRICE"
        | "PRODUCT_CONDITION_CHANGED"
        | "OTHER"
        | "DONT_ANSWER"
        | "CAN_NOT_SEND";
      /** filled in case the 'saleRejectionReasonType' is GOING_TO_CHANGE_PRICE */
      newPrice?: number;
      /** filled in case the 'saleRejectionReasonType' is OTHER */
      comment?: string;
      /** filled in case the 'saleRejectionReasonType' is SOLD_ON_OTHER_PLATFORM */
      salePlatform?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/confirmPosition`,
      method: "PATCH",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetDeliveryAddressEndpointUsingPut1
   * @summary setDeliveryAddressEndpoint
   * @request PUT:/api/v2/orders/{orderId}/deliveryAddressEndpoint/{deliveryAddressEndpointId}
   */
  setDeliveryAddressEndpointUsingPut1 = (
    orderId: number,
    deliveryAddressEndpointId: number,
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/deliveryAddressEndpoint/${deliveryAddressEndpointId}`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-international-api-v-2
   * @name SetDeliveryAddressEndpointAggregationUsingPut1
   * @summary setDeliveryAddressEndpointAggregation
   * @request PUT:/api/v2/orders/{orderId}/deliveryAddressEndpointAggregation/{deliveryAddressEndpointAggregationId}
   */
  setDeliveryAddressEndpointAggregationUsingPut1 = (
    orderId: number,
    deliveryAddressEndpointAggregationId: number,
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/deliveryAddressEndpointAggregation/${deliveryAddressEndpointAggregationId}`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-international-api-v-2
   * @name SetPickupAddressEndpointAggregationUsingPut1
   * @summary setPickupAddressEndpointAggregation
   * @request PUT:/api/v2/orders/{orderId}/pickupAddressEndpointAggregation
   */
  setPickupAddressEndpointAggregationUsingPut1 = (
    orderId: number,
    query: {
      /**
       * deliveryAddressEndpointAggregationId
       * @format int64
       */
      pickupAddressEndpointAggregationId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/pickupAddressEndpointAggregation`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetDeliveryCommentUsingPut1
   * @summary setDeliveryComment
   * @request PUT:/api/v2/orders/{orderId}/deliveryComment
   */
  setDeliveryCommentUsingPut1 = (
    orderId: number,
    query: {
      /** comment */
      comment: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/deliveryComment`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name InitHoldUsingPost1
   * @summary initHold
   * @request POST:/api/v2/orders/{orderId}/hold
   */
  initHoldUsingPost1 = (
    orderId: number,
    query?: {
      /**
       * paymentBuyerCounterpartyId
       * @format int64
       */
      paymentBuyerCounterpartyId?: number;
      /** fromMobile */
      fromMobile?: boolean;
      /** Payment option type */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfInitOrderResult, void>({
      path: `/api/v2/orders/${orderId}/hold`,
      method: "POST",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetPickupAddressEndpointUsingPut
   * @summary setPickupAddressEndpoint
   * @request PUT:/api/v2/orders/{orderId}/pickupAddressEndpoint
   */
  setPickupAddressEndpointUsingPut = (
    orderId: number,
    query: {
      /**
       * pickupAddressEndpointId
       * @format int64
       */
      pickupAddressEndpointId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/pickupAddressEndpoint`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetPickupCommentUsingPut
   * @summary setPickupComment
   * @request PUT:/api/v2/orders/{orderId}/pickupComment
   */
  setPickupCommentUsingPut = (
    orderId: number,
    query: {
      /** comment */
      comment: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/pickupComment`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetPickupTimeIntervalIdUsingPut
   * @summary setPickupTimeIntervalId
   * @request PUT:/api/v2/orders/{orderId}/pickupTimeInterval
   */
  setPickupTimeIntervalIdUsingPut = (
    orderId: number,
    query: {
      /**
       * timeIntervalId
       * @format int64
       */
      timeIntervalId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/pickupTimeInterval`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetPickupDateAndTimeIntervalIdUsingPut
   * @summary setPickupDateAndTimeIntervalId
   * @request PUT:/api/v2/orders/{orderId}/pickupDateAndTimeInterval
   */
  setPickupDateAndTimeIntervalIdUsingPut = (
    orderId: number,
    query: {
      /**
       * pickupDate
       * @format date-time
       */
      pickupDate: string;
      /**
       * timeIntervalId
       * @format int64
       */
      timeIntervalId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/pickupDateAndTimeInterval`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name SetSellerCounterpartyUsingPut
   * @summary setSellerCounterparty
   * @request PUT:/api/v2/orders/{orderId}/sellerCounterparty
   */
  setSellerCounterpartyUsingPut = (
    orderId: number,
    query: {
      /**
       * sellerCounterpartyId
       * @format int64
       */
      sellerCounterpartyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Api2ResponseOfOrderDTO, void>({
      path: `/api/v2/orders/${orderId}/sellerCounterparty`,
      method: "PUT",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetOrderDocs
   * @summary Ссылки на документы заказа
   * @request GET:/api/v2/orders/{orderId}/documents
   */
  getOrderDocs = (orderId: number, params: RequestParams = {}) =>
    this.request<Api2ResponseOfListOfDocumentLinkDTO, void>({
      path: `/api/v2/orders/${orderId}/documents`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller-api-v-2
   * @name GetPaymentOptions
   * @summary Способы оплаты
   * @request GET:/api/v2/orders/paymentOptions
   */
  getPaymentOptions = (
    query?: {
      /** @format int64 */
      orderId?: number;
      /** @format int64 */
      sellerId?: number;
      promocode?: string;
      supportYandex?: boolean;
      supportSBP?: boolean;
      supportNoonApplePay?: boolean;
      supportTabby?: boolean;
      currencyCode?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      (PaymentOption | CardPaymentOption | YandexSplitPaymentOption | YandexPayPaymentOption | SplitPaymentOption)[],
      void
    >({
      path: `/api/v2/orders/paymentOptions`,
      method: "GET",
      query: query,
      ...params,
    });
}
